import { render, staticRenderFns } from "./adminMange.vue?vue&type=template&id=47d57e08&scoped=true&"
import script from "./adminMange.vue?vue&type=script&lang=js&"
export * from "./adminMange.vue?vue&type=script&lang=js&"
import style0 from "./adminMange.vue?vue&type=style&index=0&id=47d57e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d57e08",
  null
  
)

export default component.exports